import FreeProductSignUpLink from './FreeProductSignUpLink';

export default FreeProductSignUpLink;
